import { getFunctions, httpsCallable } from 'firebase/functions';

const FN_NAME = 'generateCompanyPublicProfileQr';

export async function generateOrRegenerateCompanyPublicProfile(
  companyId,
  { regenerateQrOnly = false, allowIngresadaCloneQr = false } = {}
) {
  if (!companyId || typeof companyId !== 'string') {
    throw new Error('companyId es obligatorio');
  }
  const fn = httpsCallable(getFunctions(), FN_NAME);
  // El servidor fuerza logo al centro; enviamos el valor por contrato explícito.
  const resp = await fn({
    companyId,
    regenerateQrOnly,
    allowIngresadaCloneQr,
    logoPosition: 'center-logo',
  });
  return resp?.data || null;
}

export async function copyTextToClipboard(text) {
  if (!text) return false;
  if (navigator?.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return true;
  }
  return false;
}
